var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamouczekFiolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 9.97052H10.8457V12.0705H10.0254V9.97052Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4349 9.42572C10.6495 9.42572 10.855 9.23708 10.8451 9.01556C10.8351 8.79334 10.6648 8.60541 10.4349 8.60541C10.2204 8.60541 10.0148 8.79405 10.0248 9.01556C10.0347 9.23779 10.205 9.42572 10.4349 9.42572Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1589 6.97703V0H1.80264C0.808664 0 0 0.784875 0 1.77885V12.2504H0.00866797C0.0997773 13.2303 0.92627 14 1.92951 14H10.4401C12.403 14 14 12.4268 14 10.4639C14 8.74718 12.7784 7.31041 11.1589 6.97703ZM10.3373 6.90566C8.52991 6.95721 7.05581 8.36248 6.89508 10.1409H3.29891V0.797809H10.3373V6.90566ZM1.80264 0.797809H2.47729V10.1409H1.92951C1.51741 10.1409 1.13539 10.2712 0.821598 10.4922V1.77885C0.821598 1.23788 1.2617 0.797809 1.80264 0.797809ZM1.92951 13.1784C1.3186 13.1784 0.821598 12.6814 0.821598 12.0705C0.821598 11.4596 1.3186 10.9626 1.92951 10.9626H6.91534C6.94952 11.2053 7.00818 11.4402 7.08889 11.6648H2.08201V12.4864H7.51228C7.69054 12.7436 7.90177 12.9764 8.13985 13.1784H1.92951V13.1784ZM10.4401 13.2022C8.93025 13.2022 7.70189 11.9738 7.70189 10.4639C7.70189 8.95407 8.93025 7.72568 10.4401 7.72568C11.95 7.72568 13.1784 8.95407 13.1784 10.4639C13.1784 11.9738 11.95 13.2022 10.4401 13.2022Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49023 2.39532H8.23995V3.21692H5.49023V2.39532Z",
    fill: "#730BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56152 4.17896H9.16886V5.00055H4.56152V4.17896Z",
    fill: "#730BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamouczekFiolet);
export default __webpack_public_path__ + "static/media/samouczek-fiolet.24c76bfa7f457f6e1b234b5467418a24.svg";
export { ForwardRef as ReactComponent };